import script from "./routerButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./routerButton.vue?vue&type=script&lang=ts&setup=true"

import "./routerButton.vue?vue&type=style&index=0&id=1bf67f49&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bf67f49"]])

export default __exports__